module.exports = __webpack_public_path__ + "static/media/header-logo-alt.57094bcc.png";